var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserHeadset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 125.55 143.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#67748e;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M360.42,450.57h-54c-6.41,0-9.12-2.85-8.79-9.25a37.31,37.31,0,0,1,31.15-34.73,30,30,0,0,1,4.74-.22q26.86,0,53.73,0c15.68,0,30.42,11.37,34.39,26.62,1.07,4.09,2.19,8.24,1,12.51-.86,3.18-2.77,4.7-6.06,5-.82.08-1.66.07-2.49.07Z",
    transform: "translate(-297.64 -307.17)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M337.17,387.68a32.11,32.11,0,0,1-10.26-14.46c-7-19.32,2.7-39.88,22.22-46.24,21-6.86,43.63,5.81,46.7,29.23a53.35,53.35,0,0,1,.1,11.23c-.54,6.79-8,12.27-14.74,11.11a2.75,2.75,0,0,1-1.48-1.09,17.81,17.81,0,0,0-14.64-7.76c-5.47-.12-11-.78-16.24,1.57-6.05,2.73-9.95,11.58-10.8,14",
    transform: "translate(-297.64 -307.17)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M369.57,396.56c-5,0-10,.35-15-.09s-7.51-4-7.28-9.49a8.25,8.25,0,0,1,8.17-7.88,97.91,97.91,0,0,1,10,0c4.33.23,7.12,2.86,8.2,7.14.19.75,1.08,1.91,1.61,1.89,4.65-.17,9.46.14,13.88-1,9.95-2.61,15.71-9.93,16.42-20.49.75-11.22-1.25-21.93-7.94-31.31-8.48-11.9-20-18.64-34.67-19.4-24.46-1.26-44.47,15.84-47.31,40.17-.35,3.05-.38,6.13-.52,9.2-.13,2.77-1.53,4.27-4.11,4.3s-4.14-1.46-4.28-4.17c-1.19-23.46,10.32-44.61,32.67-54,24.53-10.29,53.29-1.53,67.05,21.63,7.61,12.81,9.56,26.72,6.4,41.13-2.47,11.31-14.13,21.68-26.84,22.19-5.48.22-11,.11-16.5.11C369.54,396.54,369.57,396.51,369.57,396.56Z",
    transform: "translate(-297.64 -307.17)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserHeadset);
export default __webpack_public_path__ + "static/media/user-headset.c04a043be51af9ee2fcf7f273add503a.svg";
export { ForwardRef as ReactComponent };